<template>
    <div class="filter-container">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="100px">
        <el-form-item label="索赔单号">
          <el-input
            v-model="searchForm.claimStatementId"
            placeholder="请输入索赔单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="索赔单状态" >
          <el-select
            v-model="searchForm.status"
            :clearable="this.status ? false : true"
            filterable
          >
            <el-option
              v-for="(item, index) in statusList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="客户账号">
          <el-input
            v-model="searchForm.customerAccount"
            placeholder="请输入客户账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="销售订单号">
          <el-input
            v-model="searchForm.claimStatementNum"
            placeholder="请输入销售订单号"
          ></el-input>
        </el-form-item>

        <el-form-item label="故障件件号">
          <el-input
            v-model="searchForm.faultPartNumber"
            placeholder="请输入故障件件号"
          ></el-input>
        </el-form-item>
        <el-form-item label="故障件名称">
          <el-input
            v-model="searchForm.faultPartNameZh"
            placeholder="请输入故障件名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户索赔单号">
          <el-input
            v-model="searchForm.customerClaimNumber"
            placeholder="请输入客户索赔单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="责任方">
          <el-select v-model="searchForm.responsibilityDepartment" filterable clearable placeholder="请选择责任方">
            <el-option
              v-for="(item, index) in responsibilityPartList"
              :key="index"
              :label="item.value"
              :value="item.codeText"
            ></el-option>
          </el-select>
          <el-input
            v-if="searchForm.responsibilityDepartment === '供应商'"
            style="margin-left: 10px"
            v-model="searchForm.responsibilitySupplierName"
            placeholder="请输入供应商名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="零部件专业">
          <el-select v-model="searchForm.lbjzy" filterable clearable placeholder="请选择零部件专业">
            <el-option
              v-for="(item, index) in partMajorList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="索赔类型">
          <el-select v-model="searchForm.claimType" filterable clearable placeholder="请选择索赔类型">
            <el-option
              v-for="(item, index) in splxList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发生日期" >
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="searchForm.happenTime"
            type="daterange"
            align="right"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="预审时间">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="searchForm.date"
            type="daterange"
            align="right"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="正审时间" >
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="searchForm.auditPassTime"
            type="daterange"
            align="right"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="国家">
          <el-select
            filterable
            clearable
            v-model="searchForm.countryId"
            placeholder="请选择国家"
          >
            <el-option
              v-for="item in nationList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

   
          <el-button
      
            type="primary"
          
            @click="handleSearch"
            >查询</el-button
          >
          <el-button  type="primary" plain @click="handleResetQuery"
            >重置</el-button
          >
        
      </el-form>
    </div>
</template>
  <script>
  import { getSession } from "@/util/localStor";
  import { getDictItem } from "@/util/dict";

  export default {
    props: {
      statusList: {
        type: Array,
        default: () => {}
      },
      status: {
        type: String,
        default: ""
      },

      type: {
        type: String,
        default: ""
      },
      recordsSearchObj: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        partMajorList: [
          {
            name: "车身",
            id: 1
          },
          {
            name: "底盘",
            id: 2
          },
          {
            name: "电器",
            id: 3
          },
          {
            name: "内外饰",
            id: 4
          },
          {
            name: "新能源",
            id: 5
          },
          {
            name: "动力",
            id: 6
          }
        ], //零部件专业
        splxList:[
            {
              name:'运输损坏',
              id:1
            },
            {
              name:'货差',
              id:2
            },
            {
              name:'质量问题',
              id:3
            },
            {
              name:'状态不符',
              id:4
            },
            {
              name:'其他',
              id:5
            },
        ],//索赔类型
        searchForm: {
          claimStatementId: "",
          status: this.status,
          claimStatementNum:"",
          customerAccount: "",
          claimType:"",
          countryId: "",
          faultPartNumber: "",
          faultPartNameZh: "",
          happenTime: "",
          responsibilityDepartment: "",
          responsibilitySupplierName: "",
          date: "",
          auditPassTime: "",
          lbjzy: "",
          customerClaimNumber: ""
        },
        nationList: [],
        responsibilityPartList: []
      };
    },
    async mounted() {
      this.searchForm = {
        ...this.searchForm,
        ...this.recordsSearchObj,
        countryId: this.recordsSearchObj?.countryId
          ? this.recordsSearchObj.countryId[0]
          : "",

      };
      this.nationList = Object.values(getSession("nationList"));
      const responsibilityPart1 = await getDictItem("responsibilityPart1");
      const responsibilityPart2 = await getDictItem("responsibilityPart2");
      const responsibilityPart3 = await getDictItem("responsibilityPart3");
      this.responsibilityPartList = [
        ...responsibilityPart2,
        ...responsibilityPart3,
        ...responsibilityPart1
      ];
    },
    methods: {
      // 搜索
      handleSearch() {
        this.$emit("handleSearch", this.searchForm);
      },

      // 重置查询条件
      handleResetQuery() {
        this.searchForm = Object.assign({}, this.$options.data().searchForm, {
          status: this.status,

        });
        this.handleSearch();
      }
    }
  };
  </script>
  <!-- <style lang="scss" scoped>
  .search {
    padding: 0 60px;
    margin-top: 15px;
    border-bottom: 5px solid #efefef;
    padding-right: 60px;
    ::v-deep .el-input {
      width: 160px;
    }
  }
  </style> -->
